import isEmailValidator from 'validator/lib/isEmail';
import { TLDs } from 'global-tld-list';

export const isEmailValid = (value: string) => {
  const userTld = value.split('.').slice(-1)[0];
  return TLDs.indexOf(userTld) >= 0 && isEmailValidator(value, { require_tld: true, domain_specific_validation: true });
};
